import { FC } from "react";


const Heading: FC = () => {

    return (
        <>
            <div className="main-content text-center">
                <h1><span>Virtual</span> Personas</h1>
                <p className="m-0">Simulation-based Learning for Hearing Care</p>
            </div>
        </>
    );

}
export default Heading;